import { useMemo } from 'react';
import { useQuery } from 'react-query';
import isEmpty from 'lodash/isEmpty';

import ResidentService from '../../../services/residentService';

// useFetchHasOpenCerts (the plain has-open-certs check, previously defined
// here but unused outside this file) moved to
// src/hooks/data-fetching/useHouseholdOpenCertsQuery.js so it can be shared.

export const useFetchHasNonMoveOutOpenCerts = ({
  organizationId,
  propertyId,
  residentId,
  isAffordable,
}: {
  organizationId: string,
  propertyId: string,
  residentId: string,
  isAffordable: boolean,
}) => {
  const residentService = useMemo(() => {
    return new ResidentService();
  }, []);

  return useQuery(
    ['hasNonMoveOutOpenCerts', organizationId, propertyId, residentId],
    async () => {
      return await residentService.getHouseholdHasNonMoveOutOpenCerts(
        organizationId,
        propertyId,
        residentId,
      );
    },
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      enabled:
        !isEmpty(organizationId ?? '') &&
        !isEmpty(propertyId ?? '') &&
        !isEmpty(residentId ?? '') &&
        isAffordable,
    },
  );
};
